import React from "react";
import StackTokenSection from "../sections/StackTokenSection/Content";
const StackTokenPage = () => {
  return <StackTokenSection />;
};

export default StackTokenPage;
